/* globals alert, confirm, console, document, google, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const async = require('async'),
    BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    user = require('../models/user'),
    Contacts = require('../collections/contacts'),
    //
    ContactsList = require('./contactsList'), // @acavan!
    ImagesSection = require('./imagesSection'),
    ModalDialog = require('./modalDialog'),
    UnitsSection = require('./unitsSection'),
    //
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    configuration = require('../utilities/configuration'),
    cookies = require('../utilities/cookies'),
    enumerations = require('../utilities/enumerations'),
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'program-details',
        name: 'programDetails'
    },
    channels: {
        analytics: BackboneRadio.channel('analytics'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childViewEvents: {
        'edit:end':             'onEditEnd',
        'edit:inProgress':      'onEditInProgress',
        'edit:start':           'onEditStart',
        'vacancy:countChanged': 'onVacancyCountChanged'
    },
    events: {
        'click img':           'onClickButton',
        'click button':        'onClickButton',
        'change @ui.address1': 'onChangeAddress',
        'change @ui.address2': 'onChangeAddress',
        'change @ui.city':     'onChangeAddress',
        'change @ui.state':    'onChangeAddress',
        'change @ui.zip':      'onChangeAddress',
        'change select':       'onChangeSelect',
        // 'dblclick h1':         'onDblClickH1',
        'input input':         'onChangeInput',
        'input textarea':      'onChangeInput'
    },
    refreshCoordinates: false,
    regions: {
        contactsList: {el: 'div[name=contactsList]', replaceElement: true},
        imagesSection: {el: 'div[name=imagesSection]', replaceElement: true},
        programDetailsContacts: {el: 'div[name=programDetailsContacts]', replaceElement: true},
        unitsSection: {el: 'div[name=unitsSection]', replaceElement: true}
    },
    tagName: 'div',
    template: templates.programDetails,
    ui: {
        contactForm:   'form[name=contact]',
        dailyLifeForm: 'form[name=dailyLife]',
        xlocationForm:  'form[name=xlocation]', // 6/15/2023 Chrome 114 crashes on view/edit program if the [name] of this form is exactly 'location'
        rulesForm:     'form[name=rules]',
        servicesForm:  'form[name=services]',
        summaryForm:   'form[name=summary]',
        //
        address1:        'input[name=address1]',
        address2:        'input[name=address2]',
        city:            'input[name=city]',
        county:          'input[name=county]',
        countyId:        'input[name=countyId]',
        state:           'input[name=state]',
        zip:             'input[name=zip]',
        website:         'input[name=website]',
        phone:           'input[name=phone]',
        latitude:        'input[name=latitude]',
        longitude:       'input[name=longitude]',
        location:        'input[name=location]',
        locationComment: 'small[name=locationComment]',
        //
        walkscore: 'div[name=walkscore]',
        //
        // contact fields only present if create...
        email: 'form[name=contact] input[name=email]',
        first: 'form[name=contact] input[name=first]',
        last: 'form[name=contact] input[name=last]',
        title: 'form[name=contact] input[name=title]',
        phoneNumbersOnly: 'form[name=contact] input[name=phoneNumbersOnly]',
        //
        favorite: 'button[data-action=favorite]',
        phoneInvalidFeedback: 'div[name=phoneInvalidFeedback]',
        websiteInvalidFeedback: 'div[name=websiteInvalidFeedback]'
    },
    currentSection: null,
    //
    close: function () {
        // jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        // jQuery(document).off('keydown', _.bind(this.onKeydown, this));
        jQuery(document).off('keyup', this.keyupHandler);
        jQuery(document).off('keydown', this.keydownHandler);
        if (!this.popout) {
            this.modal.find('div[name=programDetails]').remove();
            // this.modal.off('hide.bs.modal');
            this.modal.modal('hide');
            this.modal.modal('dispose');
            this.modal.hide();
            this.trigger('details:closed', this.model);
        }
        this.destroy();
        this.trigger('edit:end');
    },
    fetch: function () {
        this.model.fetch();
    },
    initialize: function () {
        // console.log('programDetails.initialize');
        // alert('detectSwipe.enabled:' + jQuery.detectSwipe.enabled);
        this.channels.analytics.trigger('event', { category: 'places.program', action: 'detail', label: this.model.id });
        this.organizationId = this.options.organizationId || this.model.attributes.organizationId || this.collection.organizationId;
        this.popout = this.options.popout === true;
        this.modal = jQuery('#modal');
        this.create = this.model.isNew() && !this.popout;
        if (!this.create) {
            // console.log(this.options);
            this.templateContext = {
                isFirst: this.options.offset === 1,
                isLast: this.options.count === this.options.offset,
                mapDisabled: configuration.disabledViews.programDetailsMap,
                popout: this.popout,
                popoutPrint: window.location.search.indexOf('print') !== -1,
                freshlyMinted: this.options.freshlyMinted,
                payForGroup: this.model.get('canPayForWithHousingSupport') || this.model.get('canPayPrivate')
            };
            // console.log(this.templateContext);
            if (this.popout) {
                // suppress edit bits when popped out (see also '!this.popout' below...)
                this.templateContext.hasAdminAccess = false;
            }
        } else {
            this.templateContext = {
                create: true,
                hasAdminAccess: true,
                programRoleTypeId: enumerations.codeValues.programRoleTypePrimaryContact,
                programTypeId: -1,
                programStatusTypeId: -1,
                siteTypeId: -1
            };
            this.contacts = new Contacts([], {type: 'organization', id: this.organizationId, full: true});
            this.listenTo(this.contacts, 'sync', _.bind(function (event) {
                const a = ['<option value="-1" selected>New contact</option>'];
                _.each(this.contacts.models, function (model) {
                    a.push('<option value="' + model.id + '">' + model.id + '</option>');
                });
                jQuery('select[name=existingContactId]', this.$el).html(a.join('\n'));
            }, this));
        }
        this.listenTo(this.model, 'change sync', _.bind(function () {
            // console.log('@acavan - programDetails.mode.change_sync - changed:%s', JSON.stringify(this.model.changed));
            this.refresh();
        }, this));
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.model.fetch();
        }, this));
        this.listenTo(user, 'change:JWT', _.bind(function () {
            if (!user.isSignedIn()) {
                this.pendingFavorite = false;
            } else {
                if (this.pendingFavorite) {
                    this.ui.favorite.trigger('click');
                }
            }
        }, this));
    },
    newModel: function (options) {
        this.stopListening(this.model);
        this.options = options;
        this.model = options.model;
        this.initialize();
        this.refresh(true);
    },
    onAttach: function () {
        // console.log('programDetails.onAttach');
        if (this.model.roleChanged) {
            // console.log('programDetails.onAttach.model.roleChanged');
            this.model.fetch();
        }
        this.modal.scroll(_.debounce(function (event) {
            jQuery('input[data-date=true]').datepicker('place');
        }, 10));
    },
    onChangeAddress: function () {
        this.refreshCoordinates = true;
        return false;
    },
    onChangeInput: function (event) {
        let name = event.currentTarget.name,
            emptyPhone, emptyWebsite;
        if (name === 'householdTypeIds') {
            // it should only be showing if there was no selection when the form validated so we can just clear here with impunity
            // @acavan! TODO - that said, we should show it if the form has been previously validated and then all the selections are removed... (oy!)
            this.$el.find('input[type=checkbox][name=' + name + ']').each(function (index, checkbox) {
                checkbox.setCustomValidity('');
            });
            this.$el.find('div[name=householdTypeIdsFeedback]').css('display', 'none');
        }
        if (name === 'phone' || name === 'website') {
            emptyPhone = this.ui.phone.val() === '';
            emptyWebsite = this.ui.website.val() === '';
            this.ui.phoneInvalidFeedback.html(emptyPhone && emptyWebsite ? helpers.l10n('phoneWebsiteEmptyInvalidFeedback') : helpers.l10n('phoneInvalidFeedback'));
            this.ui.websiteInvalidFeedback.html(emptyPhone && emptyWebsite ? helpers.l10n('phoneWebsiteEmptyInvalidFeedback') : helpers.l10n('websiteInvalidFeedback'));
            this.ui.phone[0].setCustomValidity(this.ui.phone[0].validity.patternMismatch ? '...' : '');
            this.ui.website[0].setCustomValidity(this.ui.website[0].validity.patternMismatch ? '...' : '');
        }
        this.onEditInProgress();
        return false;
    },
    onChangeSelect: function (event) {
        let existingContact,
            contact;
        // should only be one select but out of an abundance of caution...
        switch (event.currentTarget.name) {
            case 'existingContactId':
                existingContact = event.currentTarget.value !== '-1';
                if (existingContact) {
                    contact = this.contacts.get(event.currentTarget.value);
                }
                this.ui.email.prop('disabled', existingContact).val(existingContact ? contact.id : '');
                _.each(['first', 'last', 'title', 'phoneNumbersOnly'], _.bind(function (field) {
                    let value = '';
                    if (existingContact) {
                        switch (field) {
                            case 'phoneNumbersOnly':
                                value = helpers.telephone(contact.get(field));
                                break;
                            default:
                                value = contact.get(field);
                                break;
                        }
                    }
                    this.ui[field].prop('disabled', existingContact).val(value);
                }, this));
                break;
            default:
                break;
        }
        this.onEditInProgress();
        // console.log('organizationDetails.onChangeSelect');
    },
    onClickButton: function (event) {
        let payload,
            propagateEvent = false,
            url;
        const action = event.action || event.currentTarget.dataset.action,
            close = _.bind(this.close, this),
            section = event.currentTarget.dataset.section,
            mode = function (mode, section) {
                jQuery('div[name=display], button[name=edit]', section).toggleClass('hidden', mode === 'edit');
                jQuery('div[name=edit], button[name=save], button[name=delete], button[name=cancel]', section).toggleClass('hidden', mode === 'display');
            },
            cancel = _.bind(function () {
                if (!this.create) {
                    mode('display', jQuery(event.currentTarget).closest('div[name=' + section + ']'));
                    this.currentSection = null;
                    this.editInProgress = false;
                    // this.render();
                    this.refresh();
                } else {
                    close();
                }
            }, this),
            validationResults = {
                true: 0,
                false: 0
            },
            validateOneOfEitherPhoneOrWebsite = _.bind(function (name) {
                if (this.ui.phone.val() === '' && this.ui.website.val() === '') {
                    this.ui.phone[0].setCustomValidity('...');
                    this.ui.website[0].setCustomValidity('...');
                    return false;
                }
                this.ui.phone[0].setCustomValidity('');
                this.ui.website[0].setCustomValidity('');
                return true;
            }, this),
            validateCheckboxGroupHasMinimumOneSelected = _.bind(function (name) {
                let count = 0;
                this.$el.find('input[type=checkbox][name=' + name + ']').each(function (index, checkbox) {
                    if (checkbox.checked && +checkbox.value !== -1) { // don't count sentry value if present...
                        count++;
                    }
                });
                if (!count) {
                    this.$el.find('div[name=' + name + 'Feedback]').css('display', 'block');
                    this.$el.find('input[type=checkbox][name=' + name + ']').each(function (index, checkbox) {
                        checkbox.setCustomValidity(helpers.l10n('validation_oneOrMoreRequired'));
                    });
                }
                return count !== 0;
            }, this),
            processSection = _.bind(function (action, callback) {
                const concatenateAddress = _.bind(function () {
                        const ui = this.ui;
                        let s = '',
                            value;
                        _.each(['address1', 'address2', 'city', 'state', 'zip'], function (key) {
                            value = ui[key].val();
                            s += value ? value + ' ' : '';
                        });
                        return s;
                    }, this);
                let serializedArray;
                if (!this.currentSection && !this.editInProgress) {
                    callback(null);
                    return;
                }
                if (_.includes(['next', 'previous', 'close'], action)) {
                    if (this.editInProgress) {
                        this.modalDialog = new ModalDialog({template: templates.editInProgress, templateContext: {type: 'programLabel', name: this.model.attributes.name}, modalModal: true});
                        this.modalDialog.on('modalDialog:cancel', _.bind(function (o) {
                            this.onEditEnd();
                            callback(null);
                        }, this));
                        this.modalDialog.on('modalDialog:resume', _.bind(function (o) {
                            callback(true);
                        }, this));
                    } else {
                        callback(null);
                    }
                } else {
                    async.waterfall([
                        _.bind(function (callback) {
                            if (this.refreshCoordinates) {
                                this.addressAutocomplete.resolveLocation(concatenateAddress(), callback);
                            } else {
                                callback(null, null);
                            }
                        }, this),
                        _.bind(function (results, callback) {
                            // console.log('@acavan - onClickButton.processSection.addressAutocomplete', results);
                            const ui = this.ui;
                            if (results) {
                                _.each(results, function (value, key) {
                                    if (ui[key]) {
                                        ui[key].val(value);
                                    }
                                });
                            }
                            if (this.ui.state.val() !== 'MN') {
                                callback(helpers.l10n('programAddressMustBeInMinnesota'));
                                return;
                            }
                            serializedArray = this.ui[this.currentSection + 'Form'].serializeArray();
                            if (!this.create) {
                                this.model.update(serializedArray, callback);
                            } else {
                                this.collection.create(serializedArray, this.ui.contactForm.serializeArray(), callback);
                            }
                            this.currentSection = null;
                            this.editInProgress = false;
                        }, this)
                    ], _.bind(function (error, results) {
                        callback(error, null);
                    }, this));
                }
            }, this); // processSection
        switch (action) {
            case 'cancel':
                cancel();
                break;
            case 'close':
                processSection('close', function (error) {
                    if (!error) {
                        close();
                    }
                });
                break;
            case 'delete':
                this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'programLabel', name: this.model.attributes.name}, modalModal: true});
                this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
                    this.model.destroy();
                    this.close();
                }, this));
                break;
            case 'edit':
                this.channels.analytics.trigger('event', { category: 'places.program', action: 'edit', label: this.model.id });
                this.currentSection = section;
                // this.priorSerializedArray = this.ui[this.currentSection + 'Form'].serializeArray();
                mode('edit', jQuery(event.currentTarget).closest('div[name=' + section + ']'));
                this.toggleAddEditDisable(true);
                break;
            case 'email':
                propagateEvent = true;
                break;
            case 'favorite':
                if (user.isSignedIn()) {
                    this.pendingFavorite = false;
                    this.channels.analytics.trigger('event', { category: 'places.program', action: this.model.favorite() ? 'favorite.remove' : 'favorite.add', label: this.model.id });
                    jQuery(event.currentTarget).toggleClass('yes', this.model.favorite(!this.model.favorite()));
                    if (!cookies.hasItem('programMarkedFavorite')) {
                        if (this.model.favorite()) {
                            // only show the dialog if there was no cookie set and the user added favorite status (as opposed to removed favorite statue)
                            this.modalDialog = new ModalDialog({template: templates.programMarkedFavorite, templateContext: {}, modalModal: true});
                        }
                        cookies.setItem('programMarkedFavorite', true);
                    }
                } else {
                    this.pendingFavorite = true;
                    if (configuration.embedded) {
                        this.channels.vaultOut.trigger('requestLogon');
                    } else {
                        this.modalDialog = new ModalDialog({template: templates.pleaseSignIn, templateContext: {}, modalModal: true});
                    }
                }
                break;
            case 'next':
                processSection('next', _.bind(function (error) {
                    if (!error) {
                        // close();
                        this.trigger('next:program', this.model);
                    }
                }, this));
                break;
            case 'popout':
            case 'popoutPrint':
                if (!this.popout) {
                    this.channels.analytics.trigger('event', { category: 'places.program', action: 'popout', label: this.model.id });
                    if (configuration.embedded) {
                        url = 'https://' + user.get('host') + '/places.htm' + (action === 'popoutPrint' ? '?print' : '') + '#popout/' + this.model.id;
                    } else {
                        url = window.location.origin + window.location.pathname + (action === 'popoutPrint' ? '?print' : '') + '#popout/' + this.model.id;
                    }
                    window.open(url, '_blank');
                }
                break;
            case 'previous':
                processSection('previous', _.bind(function (error) {
                    if (!error) {
                        // close();
                        this.trigger('previous:program', this.model);
                    }
                }, this));
                break;
            case 'print':
                window.focus();
                window.print();
                break;
            case 'save':
                // console.log('programDetails.onClickButton.save - currentSection:%s', this.currentSection);
                switch (section) {
                    case 'summary':
                        validationResults[(validateCheckboxGroupHasMinimumOneSelected('householdTypeIds'))]++;
                        validationResults[validateOneOfEitherPhoneOrWebsite()]++;
                        break;
                    case 'contact':
                        validationResults[!this.ui.contactForm[0] || this.ui.contactForm[0].checkValidity()]++;
                        break;
                    default:
                        break;
                }
                // validationResults[this.currentSection !== 'summary' || this.ui.summaryForm[0].checkValidity()]++;
                // console.log('validationResults', validationResults);
                // if (validateCheckboxGroupHasMinimumOneSelected('householdTypeIds') && (this.currentSection !== 'summary' || this.ui.summaryForm[0].checkValidity()) && (!this.ui.contactForm[0] || this.ui.contactForm[0].checkValidity())) {
                if (validationResults.false === 0) {
                    processSection('save', _.bind(function (error) {
                        if (!error) {
                            if (this.create) {
                                close();
                            }
                        } else {
                            alert(error);
                        }
                    }, this));
                } else {
                    this.ui.summaryForm.toggleClass('was-validated', true);
                    this.ui.contactForm.toggleClass('was-validated', true);
                }
                break;
            default:
                console.log('programDetails.onClickButton - action:%s', action);
                break;
        }
        return propagateEvent ? true : false;
    },
    // onDblClickH1: function () {
    //     if (!configuration.embedded && configuration.credentials && configuration.credentials.username) {
    //         if (user.isSignedIn()) {
    //             user.signOut();
    //         } else {
    //             user.signIn(configuration.credentials.username, configuration.credentials.password);
    //         }
    //     }
    // },
    onDestroy: function () {
        jQuery('.pac-container').slice(1).remove();
        jQuery('.uppy-ProgressBar').remove();
    },
    onEditEnd: function () {
        this.toggleAddEditDisable(false);
        this.editInProgress = false;
    },
    onEditInProgress: function () {
        let selector = 'button[name=save]'; // if create we'll enable all (both...) the save buttons
        if (!this.editInProgress) {
            if (!this.create) {
                selector = 'div[name=' + this.currentSection + '] ' + selector;
            }
            this.$el.find(selector).attr('disabled', false);
            this.editInProgress = true;
        }
    },
    onEditStart: function () {
        this.toggleAddEditDisable(true);
    },
    onKeydown: function (event) {
        let tabPosition;
        if (event.which === 9) {
            tabPosition = document.activeElement.dataset ? document.activeElement.dataset.tabPosition : null;
            switch (tabPosition) {
                case 'first':
                    if (event.shiftKey) {
                        this.$el.find('[data-tab-position=last]').focus();
                        event.preventDefault();
                    }
                    break;
                case 'last':
                    if (!event.shiftKey) {
                        this.$el.find('[data-tab-position=first]').focus();
                        event.preventDefault();
                    }
                    break;
                default:
                    break;
            }
        }
    },
    onKeyup: function (event) {
        let selector,
            element;
        switch (event.which) {
            case 27: // escape
                // console.log(jQuery('#modalModal').is(':visible'));
                if ((!this.modalDialog || this.modalDialog.isDestroyed()) && !jQuery('#modalModal').is(':visible')) { // also watch for modalModal:visible as share dialog is not initiated here...
                    selector = '[data-action=close]';
                }
                break;
            default:
                break;
        }
        if (selector) {
            element = this.$el.find(selector);
            if (!element.attr('disabled')) {
                element.trigger('click');
            }
        }
    },
    onRender: function () {
        const ui = this.ui,
            onLocation = function (location) {
                if (!location.error) {
                    this.refreshCoordinates = false;
                    _.each(location, function (value, key) {
                        if (ui[key]) {
                            ui[key].val(value);
                        }
                    });
                    ui.location.val(location.formattedAddress);
                    ui.locationComment.text('');
                } else {
                    ui.locationComment.text(location.error);
                }
            };
        if (ui.location[0]) {
            this.addressAutocomplete = new AddressAutocomplete(ui.location[0], _.bind(onLocation, this));
            ui.location.focus(function (event) {
                this.priorAddressAutocomplete = ui.location.val();
            });
            ui.location.blur(function (event) {
                // remove any text on blur and, if an autocomplete has occurred, display the formatted address above
                if (ui.location.val() !== this.priorAddressAutocomplete) {
                    ui.location.val('');
                }
            });
        }
        if (!this.create) {
            this.$el.find('span[name=offset]').text(this.options.offset);
            this.$el.find('span[name=count]').text(this.options.count);
            this.listenTo(this.model, 'walkscore:scores', function (scores) {
                ui.walkscore.html(templates.walkscore(scores));
            });
            this.model.walkscore();
            _.defer(_.bind(function () {
                if (!this.popout) {
                    this.$el.append('<div class="iframe-marker" data-iframe-height="1"></div>');
                    this.modal.html(this.$el);
                    this.delegateEvents();  // rebind event handlers
                    this.modal.modal({backdrop: 'static', focus: false, keyboard: false});
                }
                this.showChildView('imagesSection', new ImagesSection({programId: this.model.id, hasAdminAccess: !this.popout ? this.model.get('hasAdminAccess') : false}));
                this.showChildView('unitsSection', new UnitsSection({programId: this.model.id, hasAdminAccess: !this.popout ? this.model.get('hasAdminAccess') : false}));
                if (this.model.get('hasAdminAccess') && !this.popout) {
                    this.showChildView('contactsList', new ContactsList({type: 'program', id: this.model.id, organizationId: this.organizationId, hasAdminAccess: true, title: 'contactsTitle', display: 'contactTitle'}));
                }
            }, this));
        } else {
            // if here the summary form must be showing
            this.currentSection = 'summary';
            _.defer(_.bind(function () {
                this.$el.append('<div class="iframe-marker" data-iframe-height="1"></div>');
                this.modal.html(this.$el);
                this.delegateEvents();  // rebind event handlers
                this.modal.modal({backdrop: 'static', focus: false, keyboard: false});
            }, this));
        }
        this.keyupHandler = _.bind(this.onKeyup, this);
        this.keydownHander = _.bind(this.onKeydown, this);
        jQuery(document).on('keyup', this.keyupHandler);
        jQuery(document).on('keydown', this.keydownHandler);
        this.$el.find('form input').on('invalid', function (event) {
            if (jQuery(event.currentTarget).is(':hidden')) {
                console.log('programDetails - validation failed for hidden element (name=%s)', event.currentTarget.name);
                event.preventDefault();
                return false;
            }
        });
        _.defer(_.bind(function () {
            this.$el.find('[data-tab-position=first]').focus();
        }, this));
    },
    onVacancyCountChanged: function () {
        this.model.fetch();
        this.trigger('vacancy:countChanged');
    },
    refresh: function (newProgram) {
        // jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        // jQuery(document).off('keydown', _.bind(this.onKeydown, this));
        jQuery(document).off('keyup', this.keyupHandler);
        jQuery(document).off('keydown', this.keydownHandler);
        if (!newProgram) {
            if (this.getRegion('imagesSection') && this.getChildView('imagesSection')) {
                this.getChildView('imagesSection').destroy();
            }
            if (this.getRegion('unitsSection') && this.getChildView('unitsSection')) {
                this.getChildView('unitsSection').destroy();
            }
        }
        this.render();
    },
    toggleAddEditDisable: function (disable) {
        // console.log('programDetails.toggleAddEditDisable');
        jQuery('[data-action=add]', this.$el).attr('disabled', disable);
        jQuery('[data-action=edit]', this.$el).attr('disabled', disable);
        jQuery('[data-action=select]', this.$el).attr('disabled', disable);
        jQuery('img[data-action]', this.$el).toggleClass('disabled', disable);
    }
});
